export enum ETypTransakce {
    NAKUP = 'NAKUP',
    PRODEJ = 'PRODEJ',
    SNIZENI = 'SNIZENI'
}
